export const CONFIGS = {
	CORALOGIX: {
		PUBLIC_KEY: 'cxtp_QBUVKRoh3t76RLQf261FUZRz8mPb11',
		APPLICATION: 'postpe-fe',
		DOMAIN: 'AP1',
		WHITELISTED_DOMAINS: [
			'https://postpe.bharatpe.in',
			'https://postpe-uat.bharatpe.in',
			'https://postpe-uat1.bharatpe.in',
			'https://postpe-uat2.bharatpe.in',
			'https://postpe-uat3.bharatpe.in',
			'http://localhost:3000',
		],
	},
};
